import axios from 'axios';
import { MAIN_API_URL } from '../constants/api';

const instance = axios.create({
  baseURL: MAIN_API_URL,
});

export default instance;
